import { BrowserRouter, useRoutes, Navigate } from 'react-router-dom';

import Login from '@/page/Login';
import Layout from '@/components/Layout';
import Home from '@/page/Home';
import Products from '@/page/Products';
import ProductDetail from '@/page/ProductDetail';
import About from '@/page/About';
import Contact from '@/page/Contact';
import News from '@/page/News';
import NewsDetail from '@/page/NewsDetail';
import FAQ from '@/page/FAQ';

const GetRoutes = () => {
  return useRoutes([
    { path: '/login', element: <Login /> },

    {
      path: '/',
      element: <Layout />,
      children: [
        { index: true, element: <Home /> },
        { path: 'products', element: <Products /> },
        { path: 'products/:id', element: <ProductDetail /> },
        { path: 'about', element: <About /> },
        { path: 'contact', element: <Contact /> },
        { path: 'news', element: <News /> },
        { path: 'news/:id', element: <NewsDetail /> },
        { path: 'faq', element: <FAQ /> },
      ],
    },

    { path: '*', element: <Navigate to='/' replace /> },
  ]);
};

const Router = () => {
  return (
    <BrowserRouter basename=''>
      <GetRoutes />
    </BrowserRouter>
  );
};

export default Router;
